import { render, staticRenderFns } from "./RukoGarantD12.vue?vue&type=template&id=4c7042a8&"
import script from "./RukoGarantD12.vue?vue&type=script&lang=js&"
export * from "./RukoGarantD12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports